/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_RolesInputs */

const en_member_roles = /** @type {(inputs: Member_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member Roles`)
};

const es_member_roles = /** @type {(inputs: Member_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles de Miembros`)
};

const fr_member_roles = /** @type {(inputs: Member_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rôles des membres`)
};

const de_member_roles = /** @type {(inputs: Member_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgliederrollen`)
};

const id_member_roles = /** @type {(inputs: Member_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peran Anggota`)
};

/** @type {(inputs: Member_RolesInputs) => LocalizedString} */
const ja_member_roles = en_member_roles;

/** @type {(inputs: Member_RolesInputs) => LocalizedString} */
const zh_member_roles = en_member_roles;

/** @type {(inputs: Member_RolesInputs) => LocalizedString} */
const ar_member_roles = en_member_roles;

/** @type {(inputs: Member_RolesInputs) => LocalizedString} */
const it_member_roles = en_member_roles;

/** @type {(inputs: Member_RolesInputs) => LocalizedString} */
const ru_member_roles = en_member_roles;

/** @type {(inputs: Member_RolesInputs) => LocalizedString} */
const pt_member_roles = en_member_roles;

/** @type {(inputs: Member_RolesInputs) => LocalizedString} */
const ko_member_roles = en_member_roles;

/**
* | output |
* | --- |
* | "Member Roles" |
*
* @param {Member_RolesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const member_roles = /** @type {((inputs?: Member_RolesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_RolesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_member_roles(inputs)
	if (locale === "es") return es_member_roles(inputs)
	if (locale === "fr") return fr_member_roles(inputs)
	if (locale === "de") return de_member_roles(inputs)
	if (locale === "ja") return ja_member_roles(inputs)
	if (locale === "zh") return zh_member_roles(inputs)
	if (locale === "ar") return ar_member_roles(inputs)
	if (locale === "id") return id_member_roles(inputs)
	if (locale === "it") return it_member_roles(inputs)
	if (locale === "ru") return ru_member_roles(inputs)
	if (locale === "pt") return pt_member_roles(inputs)
	return ko_member_roles(inputs)
});